/**
 * @module use-cases/shippingModel/actions
 * @desc Shipping Model Action Creators
 *
 */

import type { BusinessModel, ResellerDeliveryMode, ShippingModel } from 'core/domains';
import { createAsyncAction, createAction } from 'core/use-cases/utilities';

export const availableDeliveryModesFetch = createAsyncAction<
  'availableDeliveryModesFetch',
  { tries: number },
  BusinessModel
>('availableDeliveryModesFetch');

export const currentDeliveryModeFetch = createAsyncAction<
  'currentDeliveryModeFetch',
  ResellerDeliveryMode
>('currentDeliveryModeFetch');

export const toggleNewShippingModelActive = createAction<
  'toggleNewShippingModelActive',
  ShippingModel['toggleActive']
>('toggleNewShippingModelActive');
